import {forwardRef} from "react";

import hcp from "@images/home/suit/hcp-back.png";
import {motion} from "framer-motion";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";

import styles from "./styles.module.scss";

const HcpCard = forwardRef(({title, subTitle}, ref) => {
  return (
    <article
      className={styles.hcp_card}
      ref={ref}
    >
      <i />

      {title}

      {subTitle}
    </article>
  );
});

export const MHcpCard = motion(HcpCard);

export const Hcp = () => {
  const {isMobile} = useSelector((state) => state.common.settings);
  const {t} = useTranslation();

  const itemAnimation = {
    hidden: {
      transform: `scale(0.6) ${!isMobile && "translateX(-50%)"}`,
      opacity: 0,
    },
    visible: (custom) => ({
      transform: `scale(1) ${!isMobile && "translateX(-50%)"}`,
      opacity: 1,
      transition: {
        delay: custom * 0.3,
      },
    }),
  };

  const hcpCards = [
    {
      id: 0,
      title: (
        <h4
          dangerouslySetInnerHTML={{
            __html: t("page.suit.hcp.card.title_6"),
          }}
        />
      ),
      subTitle: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.suit.hcp.card.desc_6"),
          }}
        />
      ),
    },
    {
      id: 1,
      title: (
        <h4
          dangerouslySetInnerHTML={{
            __html: t("page.suit.hcp.card.title_1"),
          }}
        />
      ),
      subTitle: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.suit.hcp.card.desc_1"),
          }}
        />
      ),
    },
    {
      id: 2,
      title: (
        <h4
          dangerouslySetInnerHTML={{
            __html: t("page.suit.hcp.card.title_2"),
          }}
        />
      ),
      subTitle: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.suit.hcp.card.desc_2"),
          }}
        />
      ),
    },
    {
      id: 3,
      title: (
        <h4
          dangerouslySetInnerHTML={{
            __html: t("page.suit.hcp.card.title_3"),
          }}
        />
      ),
      subTitle: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.suit.hcp.card.desc_3"),
          }}
        />
      ),
    },
    {
      id: 4,
      title: (
        <h4
          dangerouslySetInnerHTML={{
            __html: t("page.suit.hcp.card.title_4"),
          }}
        />
      ),
      subTitle: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.suit.hcp.card.desc_4"),
          }}
        />
      ),
    },
    {
      id: 5,
      title: (
        <h4
          dangerouslySetInnerHTML={{
            __html: t("page.suit.hcp.card.title_5"),
          }}
        />
      ),
      subTitle: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.suit.hcp.card.desc_5"),
          }}
        />
      ),
    },
    {
      id: 6,
      title: (
        <h4
          dangerouslySetInnerHTML={{
            __html: t("page.suit.hcp.card.title_7"),
          }}
        />
      ),
      subTitle: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.suit.hcp.card.desc_7"),
          }}
        />
      ),
    },
  ];

  return (
    <div className={styles.hcp_wrapper}>
      <h3
        dangerouslySetInnerHTML={{
          __html: t("page.suit.hcp.title"),
        }}
      />

      <motion.div
        initial={"hidden"}
        whileInView={"visible"}
        viewport={{amount: 0, once: true}}
        className={styles.hcp_cards}
      >
        {hcpCards &&
          hcpCards.length > 0 &&
          hcpCards.map((card) => (
            <MHcpCard
              custom={card.id + 1}
              variants={itemAnimation}
              key={card.id}
              title={card.title}
              subTitle={card.subTitle}
            />
          ))}
      </motion.div>

      <div className={styles.hcp_back}>
        <img
          src={hcp}
          alt={"hcp"}
        />
      </div>

      <div className={styles.hcp_bottom}>
        <p
          dangerouslySetInnerHTML={{
            __html: t("page.suit.hcp.desc"),
          }}
        />
      </div>
    </div>
  );
};
